"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var navigation_bar_type_1 = require("./navigation-bar-type");
var utils_1 = require("../utils/utils");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var NavigationItem = /** @class */ (function () {
    function NavigationItem(_icon, _title, _routLink, _permissionKey, _children, _navBarType) {
        this._icon = _icon;
        this._title = _title;
        this._routLink = _routLink;
        this._permissionKey = _permissionKey;
        this._children = _children;
        this._navBarType = _navBarType;
    }
    Object.defineProperty(NavigationItem.prototype, "icon", {
        get: function () {
            return this._icon;
        },
        set: function (value) {
            this._icon = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationItem.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this._title = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationItem.prototype, "routLink", {
        get: function () {
            return this._routLink;
        },
        set: function (value) {
            this._routLink = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationItem.prototype, "permissionKey", {
        get: function () {
            return this._permissionKey;
        },
        set: function (value) {
            this._permissionKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationItem.prototype, "children", {
        get: function () {
            return this._children;
        },
        set: function (value) {
            this._children = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationItem.prototype, "navBarType", {
        get: function () {
            return this._navBarType;
        },
        set: function (value) {
            this._navBarType = value;
        },
        enumerable: true,
        configurable: true
    });
    NavigationItem.fromJson = function (navigationItem) {
        var children = navigationItem.children;
        var childrenList = new Array();
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var child = children_1[_i];
            if (child.children != null && child.children.length > 0) {
                childrenList.push(NavigationItem.fromJson(child));
            }
            else {
                childrenList.push(new NavigationItem(child.icon, new idm_crosscutting_concepts_frontend_1.MultilingualString(utils_1.Utils.convertObjectToMap(child.title)), child.routLink, child.permissionKey, [], child.navBarType === "GROUP" ? navigation_bar_type_1.NavigationBarType.GROUP : navigation_bar_type_1.NavigationBarType.ITEM));
            }
        }
        return new NavigationItem(navigationItem.icon, new idm_crosscutting_concepts_frontend_1.MultilingualString(utils_1.Utils.convertObjectToMap(navigationItem.title)), navigationItem.routLink, navigationItem.permissionKey, childrenList, navigationItem.navBarType === "GROUP" ? navigation_bar_type_1.NavigationBarType.GROUP : navigation_bar_type_1.NavigationBarType.ITEM);
    };
    NavigationItem.prototype.toJsonObject = function () {
        var titleObject = utils_1.Utils.mapToObject((this._title.toMap()));
        var navigationChildren = [];
        for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child._children.length > 0) {
                navigationChildren.push(child.toJsonObject());
            }
            else {
                navigationChildren.push(NavigationItem.simplifyNavigationItem(child._icon, utils_1.Utils.mapToObject((child._title.toMap())), child._routLink, child._permissionKey, [], child._navBarType));
            }
        }
        return NavigationItem.simplifyNavigationItem(this._icon, titleObject, this._routLink, this._permissionKey, navigationChildren, this._navBarType);
    };
    NavigationItem.simplifyNavigationItem = function (icon, title, routLink, permissionKey, children, navBarType) {
        return {
            icon: icon,
            title: title,
            routLink: routLink,
            permissionKey: permissionKey,
            children: children,
            navBarType: navBarType
        };
    };
    NavigationItem.prototype.toJson = function () {
        return JSON.stringify(this.toJsonObject());
    };
    return NavigationItem;
}());
exports.NavigationItem = NavigationItem;
//# sourceMappingURL=navigationItem.model.js.map